import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TeamService } from '../team-create/team.service';
import { Teams } from '../model/Teams';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ManageUserService } from '../services/manage-user-service';
import { HelperService } from '../services/helper-service';
import { ToastService } from '../services/toast.service';
import { SharedServiceService } from '../services/shared-service.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-team-edit',
  standalone: true,
  imports: [MatInputModule, MatFormFieldModule, FormsModule, CommonModule, MatProgressSpinnerModule],
  templateUrl: './team-edit.component.html',
  styleUrls: ['./team-edit.component.css']
})
export class TeamEditComponent implements OnInit {
  @ViewChild('selectElem') selectElem!: ElementRef<HTMLSelectElement>;
  teamId: string | null = null;
  cities: any[] = [];
  states: any[] = [];
  state = 'Andaman and Nicobar Islands';
  city = 'Port Blair';
  country = 'india';
  doctor: any;
  zipCode: string = '';
  addressLine1 = '';
  addressLine2 = '';
  emmgram = 'Choose Option';
  countries: any[] = [];
  diabetesTypeArr: any[] = [];
  diabetesSub: any[] = [];
  isLoading = 1;
  team: Teams = {
    teamId: '',
    teamName: '',
    teamType: '',
    description: '',
    ageOfDibeties: '',
    teamAddress: {
      addressLine1: '',
      state: '',
      city: '',
      addressLine2: '',
      zipCode: '',
      country: ''
    },
    enneagramType: {
      id: '',
      name: '',
      description: ''
    },
    diabetesType: '',
    diabetesSubType: '',
    status: '',
    userIds: [],
    policy: '',
    usersAssigned: []
  };
  userList: any[] = [];
  selectedDoctor = '';
  fitnessId = '';
  nutrientId = '';
  phyId = '';
  memberAdvocateId = '';
  allDoctors: any[] = [];
  allFitness: any[] = [];
  allNutrient: any[] = [];
  allPhy: any[] = [];
  allMemberAdvocate: any[] = [];
  enngramTest: any[] = [];
  selectedEnngramType = '';
  selectedDiabetesType = '';
  selectedMemberAdvocate = '';
  selectedFitnessInstructor = '';
  selectedNutritionist = '';
  selectedPhysiotherapist = '';
  selectedPolicy = '';
  isAdmin: boolean;
  constructor(
    private manageUserService: ManageUserService,
    private helperService: HelperService,
    private route: Router,
    private teamService: TeamService,
    private toast: ToastService,
    private router: ActivatedRoute,
    private SharedService: SharedServiceService
  ) {

    var role = this.SharedService.getloggedUserRole();


    if (role == 'Administrator') {
      this.isAdmin = true;
    }
    else if (role != 'Administrator') {
      this.isAdmin = false;
    }
  }

  ngOnInit(): void {
    this.loadUsers();
    this.loadDiabetesTypes();

    this.router.paramMap.subscribe(params => {
      this.teamId = this.router.snapshot.queryParamMap.get('id') || '';
      if (this.teamId) {
        this.teamService.getTeamById(this.teamId).subscribe((data) => {
          this.team = data;
          this.team.teamId = this.teamId || '';
          this.team.userIds = this.team.userIds || [];
          this.team.usersAssigned = this.team.usersAssigned || [];
          this.loadEnneagramTypes(this.team.enneagramType.id);
          this.selectedDiabetesType = this.diabetesTypeArr.find((x: any) => x.name === this.team.diabetesType)?.name || '';
          this.selectedPolicy = this.team.teamType || this.selectedPolicy;
          this.team.usersAssigned.forEach((x: { userRoles: any[]; id: string; }) => {
            if (x.userRoles[0].userRole === 'Member Advocate') {
              this.selectedMemberAdvocate = x.id;
              this.memberAdvocateId = this.selectedMemberAdvocate;
            } else if (x.userRoles[0].userRole === 'Doctor') {
              this.selectedDoctor = x.id;
            } else if (x.userRoles[0].userRole === 'Nutritionist') {
              this.selectedNutritionist = x.id;
              this.nutrientId = this.selectedNutritionist;
            } else if (x.userRoles[0].userRole === 'Fitness Instructor') {
              this.selectedFitnessInstructor = x.id;
              this.fitnessId = this.selectedFitnessInstructor;
            } else if (x.userRoles[0].userRole === 'Psychologists') {
              this.selectedPhysiotherapist = x.id;
              this.phyId = this.selectedPhysiotherapist;
            }
          });
          this.loadCountryStateData(this.team.teamAddress.country);
        });
      }
    });
  }


  private loadUsers(): void {
    this.manageUserService.getAllUsers('', '', 100).subscribe((response: any) => {
      this.userList = response;
      this.allMemberAdvocate = this.filterUsersByRole('Member Advocate');
      this.allDoctors = this.filterUsersByRole('Doctor');
      this.allNutrient = this.filterUsersByRole('Nutritionist');
      this.allFitness = this.filterUsersByRole('Fitness Instructor');
      this.allPhy = this.filterUsersByRole('Psychologists');
    });
  }

  private filterUsersByRole(role: string): any[] {
    return this.userList.filter((user: any) =>
      user.userRoles?.some((userRole: any) => userRole.userRole === role)
    );
  }

  private loadCountryStateData(country: string): void {
    this.helperService.getCountryStateForAddForm(country).subscribe((response: any) => {
      this.isLoading = 2;
      this.countries = response;
      this.cities = response[1];
      this.states = response[2];

      this.country = this.team.teamAddress.country.toLocaleLowerCase() || 'India';
      this.state = this.team.teamAddress.state || this.states[0]?.name || '';
      const cityList = this.countries[2]?.filter((state: any) => state.name === this.state);
      this.cities = cityList[0]?.cities || [];
      this.city = this.team.teamAddress.city || this.cities[0]?.name || '';
      this.zipCode = this.team.teamAddress.zipCode || '';
    });
  }

  private loadEnneagramTypes(ennId:any): void {
    this.teamService.getEnneagramType().subscribe((response: any) => {
      this.enngramTest = response;
      this.selectedEnngramType = this.enngramTest.find((x: any) => x.id === ennId)?.id || '';
      this.emmgram = this.selectedEnngramType;
    });
  }

  private loadDiabetesTypes(): void {
    this.teamService.getDiabetesType().subscribe((response: any) => {
      this.diabetesTypeArr = response;
      this.selectedDiabetesType = this.diabetesTypeArr.find((x: any) => x.name === this.team.diabetesType)?.name || '';

    });
  }

  onSubmit(): void {
    this.updateTeam();
  }

  getCountry(event: any): void {
    const country = event.target.value;
    this.loadCountryStateData(country);
    this.state = this.states[0]?.name || '';
    this.city = this.cities[0]?.name || '';
    this.country = country;
  }

  SelectedRow(event: any): void {
    const selectedState = event.target.value;
    const cityList = this.countries[2]?.filter((state: any) => state.name === selectedState);
    this.cities = cityList[0]?.cities || [];
    this.city = '';
  }

  updateTeam(): void {
    if (!this.isFormValid()) {
      return;
    }

    const selectedEnneagram = this.enngramTest.find((x: any) => x.id === this.emmgram);
    if (selectedEnneagram) {
      this.team.enneagramType = {
        id: selectedEnneagram.id,
        name: selectedEnneagram.name,
        description: selectedEnneagram.description
      };
    }

    this.addSelectedUsersToTeam();

    this.team.teamAddress = {
      state: this.state,
      addressLine1: '',
      addressLine2: '',
      city: this.city,
      country: this.country,
      zipCode: ''
    };
    if (this.teamId) {
      this.teamService.updateTeam(this.team, this.teamId).subscribe(() => {
        this.toast.successMessage('Team updated successfully!');
      });
    }

  }

  private isFormValid(): boolean {
    if(!this.team.teamName){
      this.toast.errorMessage('Please enter team name.');
    }
    else if(!this.team.diabetesType){
      this.toast.errorMessage('Please select diabetes type.');
    }
    else if(!this.memberAdvocateId){
      this.toast.errorMessage('Please select member advocate.');
    }
    else if(!this.state){
      this.toast.errorMessage('Please select state.');
    }
    else if(!this.city){
      this.toast.errorMessage('Please select city.');
    }
    else if(!this.emmgram){
      this.toast.errorMessage('Please select engram type.');
    }
    return (
      !!this.team.teamName &&
      !!this.team.diabetesType &&
      !!this.memberAdvocateId &&
      !!this.state &&
      !!this.city &&
      !!this.emmgram
    );
  }

  private addSelectedUsersToTeam(): void {
    [this.selectedDoctor, this.memberAdvocateId, this.nutrientId, this.fitnessId, this.phyId].forEach((id) => {
      if (id) this.team.userIds.push(id);
    });
  }

  SelectLevel(event: any): void {
    this.team.teamType = event.target.value;
  }

  selectEnngramType(event: any): void {
    this.emmgram = event.target.value;
  }

  selectDiabetesType(event: any): void {
    this.team.diabetesType = event.target.value;
  }

  selectDoctor(event: any): void {
    this.selectedDoctor = event.target.value;
  }

  selectMemberAdvocate(event: any): void {
    this.selectedMemberAdvocate = event.target.value;
    this.memberAdvocateId = this.selectedMemberAdvocate;
  }

  selectFitnessInstructor(event: any): void {
    this.selectedFitnessInstructor = event.target.value;
    this.fitnessId = this.selectedFitnessInstructor;
  }

  selectNutritionist(event: any): void {
    this.selectedNutritionist = event.target.value;
    this.nutrientId = this.selectedNutritionist;
  }

  selectPhysiotherapist(event: any): void {
    this.selectedPhysiotherapist = event.target.value;
    this.phyId = this.selectedPhysiotherapist;
  }

  selectPolicy(event: any): void {
    this.selectedPolicy = event.target.value;
    this.team.policy = this.selectedPolicy;
  }
}
